// UI 表示文言の一元管理。renderWord と組み合わせて使う。
//   - **強調** は太字に整形される
//   - \n は改行

export const WORD = {
  masterList: {
    info: "各マスタと、工事ごとの **個別工事情報** をまとめて編集できます。",
  },
  mastersConfigs: {
    areaDivisionLabelsInfo:
      "場所区分マスタ（区分1〜10）の選択肢に「どんなラベルで参照されるか」を設定します。空欄＝当該スロットを使用しない。「必須」ON のスロットは入力必須として扱われます。",
    hLocationDivisionParentPath:
      "この区分が属する上位の区分を指定します。指定したスロットだけが施工箇所登録での絞り込み条件になります（空欄＝制約なし）。",
    locationDivisionTopSlot:
      "区分1は最上位のため、上位区分のパスはありません。",
    hWorkSubtypeUnit:
      "施工箇所の計画数量の単位。施工数量総括表の単位と揃えてください（例: m² / m / 個）。",
    hWorkSubtypePrimaryDetail:
      "この種別の進捗実績を計上する基準工程。例: 剥落防止/防水あり → 主材兼上塗り。未設定なら全工程の完了比率で按分。",
    hQualityName:
      "表面含水率 / 膜厚 等",
    hQualityUnit:
      "% / μ / mm 等",
    hQualityTiming:
      "プライマー塗布前 / 主材塗布後 等",
    hPotLifeDefinitionName:
      "例: 温度範囲／気温帯別／冬季 など",
    hPotLifeTempLower:
      "空欄＝下限なし",
    hPotLifeTempUpper:
      "空欄＝上限なし",
    hPotLifeMinutes:
      "空欄＝可使時間制限なし（温度区間のみ定義）",
  },
  user: {
    listInfo:
      "登録されているユーザーの一覧です。クリックで詳細を表示します。ユーザーの追加・編集は管理者が行います(この画面は閲覧専用です)。",
  },
  reportList: {
    listInfo:
      "全 8 帳票を Excel ファイルとしてダウンロードします。**対象工事**を選択してから「ダウンロード」ボタンを押してください。",
  },
  stock: {
    infoMain:
      "材料ロット単位の在庫管理ページです。**搬入済かつ未消費**の QR 個体数を「現在庫」として集計します。",
    infoNote:
      "「貼付済」=ロットに紐付けた QR 数、「搬入済」=carry_in 済、「消費済」=施工で使用済。",
  },
  quantityPlan: {
    listInfo:
      "選択中の工事について、種別(WorkSubtype)単位で**計画 vs 実績**を表示します。",
  },
  constructionPlan: {
    listInfo:
      "配下が 10 件以下になるとフラット展開されます。",
  },
  materialTracking: {
    tabInfo:
      "工事を選択し、材料ごとの進捗を 2 つのサブタブで確認。**準備数量進捗**＝この工事に搬入済みの QR に対する消費の割合（搬入済／消費済）。**計画数量進捗**＝主材料計画数量に対する消費材料量の割合（未施工／消費済、計画超過時は 100% で⚠️表示）。バーのクリックで材料検索ページへ。",
  },
  workMaster: {
    listInfo:
      "行をクリックすると工事の概要が展開されます。「編集を開く」で工事情報を編集できます。",
    infoTabInfo:
      "発注者提出の帳票で使う固定フィールドです。**整理番号 / 略称 / 正式名称 / 工事型区分 / 発注者**は必須です。入力後「保存」を押してください。",
    labelsTabInfo: (areaDivisionId: number | string, areaDivisionName: string) =>
      `場所区分ラベル設定は **工事型区分マスタ** 側で管理されています。\nこの工事の工事型区分: **#${areaDivisionId} ${areaDivisionName}**`,
    accessTabInfo:
      "この工事に登録されている技術者の一覧です（参照のみ）。追加・変更は「工事情報」タブから行います。",
    hAreaDivision:
      "工種・種別・場所区分・場所区分ラベルなど、工事型区分ごとに分かれたマスタの絞り込みに使います。",
  },
  workClassification: {
    listInfo:
      "工種を開くと配下の **種別**、種別を開くと配下の **工程** を編集できます。同じ工程名が別の (工種, 種別) の下に重複登録されてもOK。",
    workTypeDialogInfo:
      "配合比は **工程** レベルでのみ設定します。工種は 1 つ以上の **種別** を持つ必要があります — 保存後に「種別を追加」してください。",
    workSubtypeDialogInfo:
      "配合比は **工程** レベルでのみ設定します。種別は 1 つ以上の **工程** を持つ必要があります — 保存後に「工程を追加」してください。",
    hMixRatio:
      "未設定の場合「⚠ 配合比未確定」警告バッジが付きます。素地調整など材料不要の工程は未設定で OK",
    hWorkSubtype:
      "工程は必ずいずれかの種別の配下に紐付きます",
  },
  mixRatio: {
    listInfo:
      "各配合比定義の行を展開すると **配合比明細**（構成細目 × 配合比範囲）を編集できます。構成細目は **材料 / 細目名** から選択します。\n配合比率は **明細から自動表示** されます。「備考」欄は攪拌のコツ等のメモ用です（配合比率は書かない）。",
    defDialogInfo:
      "保存後にアコーディオンを開いて配合比明細（構成細目 × 配合比範囲）を追加してください。配合比率は明細から自動で表示されます（例: 「主剤 1 : 硬化剤 0.12〜0.15」）。",
    hDetailMaterialDetail:
      "配合する材料細目を選択（材料 / 細目名）。単位は材料細目の容量単位を継承します。",
    hRatioEnd:
      "範囲なしは空欄でOK",
    hDerivedUnit:
      "材料マスタ側の単位",
    hMaterial:
      "材料区分に紐付く材料のみ選択可能",
    hConstructionMethod:
      "同じ材料でも施工方法が違えば別に登録します（例: 吹付 vs 左官）",
    hStirringMethod:
      "同じ材料でも撹拌方法が違えば別に登録します（例: ハンドミキサー vs 左官ミキサー）",
    hRemarks:
      "攪拌のコツ・注意点等の自由記入欄。配合比率は「配合比明細」で設定するためここには書きません",
  },
  materialMaster: {
    listInfo:
      "各材料の行をクリックして展開すると **材料細目** が編集できます。新規材料追加時はデフォルト細目「本体」が自動で 1 件作成されます。",
    materialDialogInfo:
      "保存時にデフォルト細目「本体」(QR管理=ON) が 1 件自動追加されます。後でアコーディオンから編集してください。",
    hDetailName:
      "主剤／硬化剤／粉体／清水／座金 等 (QR管理フラグは材料マスタ側で設定)",
    hContentUnit:
      "kg / L / 個 等",
    hUsageCategory:
      "注入材／遮塩モルタル／プライマー 等",
    hQrManaged:
      "ON=主材料 (QR発行・出荷・搬入対象) / OFF=副資材 (清水・座金・シール材等)",
    hPackageForm:
      "主剤500g/缶,硬化剤60g/缶 等",
    hStandardUsage:
      "施工計画の計画数量計算には使われません",
    hStandardUsageUnit:
      "kg/m² / g/m² 等",
    hRemarks:
      "複数定義（接着工1層目/2層目 等）や用途別の注記など、構造化しきれない情報をフリーテキストで記入",
  },
};
